"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var axios_cache_adapter_1 = require("axios-cache-adapter");
var delay_1 = __importDefault(require("delay"));
var qs_1 = require("qs");
var auth_1 = require("../auth");
var Config_1 = require("../Config");
var localStore_1 = require("../utils/localStore");
var _1 = require("./");
var METHOD;
(function (METHOD) {
    METHOD["POST"] = "post";
    METHOD["GET"] = "get";
    METHOD["PUT"] = "put";
    METHOD["PATCH"] = "patch";
    METHOD["DELETE"] = "delete";
})(METHOD = exports.METHOD || (exports.METHOD = {}));
exports.api = axios_1.default.create();
var Model = /** @class */ (function () {
    function Model(id) {
        var _this = this;
        /**
         * copy
         * returns a clone of the current instance, without ID set
         *
         * @return {Model}
         */
        this.copy = function () {
            var clone = Object.assign(Object.create(_this), _this);
            clone.id = undefined;
            return clone;
        };
        /**
         * Protected methods
         */
        /*
         * checkIfPropertyIsFetched
         * Checks if a property is already fetched before.
         * If so it will return the function. If not, it will
         * run the function to fetch it.
         *
         * @param {string} property
         * @param {Function<Promise<T>>}
         * @return {Promise<any>}
         */
        this.checkIfPropertyIsFetched = function (key, fn) { return __awaiter(_this, void 0, void 0, function () {
            var property;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        property = this[key];
                        if (!!property) return [3 /*break*/, 2];
                        return [4 /*yield*/, fn()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this[key]];
                }
            });
        }); };
        this.setId = id;
    }
    /**
     * Public methods
     */
    /**
     * save
     * method to save the changes made
     * to the current class.
     *
     * @returns {Promise<this>}
     */
    Model.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay_1.default(1000)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    /**
     * fetchNestedModel
     * fetches a nested model and runs the setter to store
     * it to the model
     *
     * @param {string} setter
     * @param {(...params: any[]) => Promise<T>} fn
     * @param {string} keys
     * @returns {Promise<void>}
     */
    Model.prototype.fetchNestedModel = function (setter, fn) {
        // tslint:disable-next-line:trailing-comma
        var keys = [];
        for (
        // tslint:disable-next-line:trailing-comma
        var _i = 2; 
        // tslint:disable-next-line:trailing-comma
        _i < arguments.length; 
        // tslint:disable-next-line:trailing-comma
        _i++) {
            // tslint:disable-next-line:trailing-comma
            keys[_i - 2] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var params, _a, keys_1, key, property, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        params = [];
                        _a = 0, keys_1 = keys;
                        _d.label = 1;
                    case 1:
                        if (!(_a < keys_1.length)) return [3 /*break*/, 5];
                        key = keys_1[_a];
                        if (!(typeof key !== 'string')) return [3 /*break*/, 2];
                        params.push(key);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this[key]];
                    case 3:
                        property = _d.sent();
                        if (!property) {
                            throw new Error("Property " + key + " is not set on model " + this.constructor.name);
                        }
                        params.push(property);
                        _d.label = 4;
                    case 4:
                        _a++;
                        return [3 /*break*/, 1];
                    case 5:
                        ;
                        _b = this;
                        _c = setter;
                        return [4 /*yield*/, fn.apply(void 0, params)];
                    case 6:
                        _b[_c] = _d.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Object.defineProperty(Model.prototype, "getId", {
        /**
         * Getters
         */
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "getEndpoint", {
        get: function () {
            return this.endpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "setId", {
        /**
         * Setters
         */
        set: function (id) {
            this.id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "setEndpoint", {
        set: function (endpoint) {
            this.endpoint = endpoint;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * makeRequest
     * Make a request to the API to fetch data
     *
     * @param {string} endpoint
     * @param {METHOD} method
     * @param payload
     * @param {boolean} reattempt
     * @param extraHeaders
     * @returns {Promise<T>}
     */
    Model.makeRequest = function (endpoint, method, payload, reattempt, extraHeaders, isArrayBrackets, responseType) {
        if (payload === void 0) { payload = undefined; }
        if (reattempt === void 0) { reattempt = false; }
        if (extraHeaders === void 0) { extraHeaders = undefined; }
        if (isArrayBrackets === void 0) { isArrayBrackets = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var cache, headers, _a, _b, _c, axiosParams, result, access, reattemptRequest;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (Config_1.config.getOption('store') && Config_1.config.getOption('cache')) {
                            cache = axios_cache_adapter_1.setupCache({
                                key: function (request) { return request.url + qs_1.stringify(request.params); },
                                maxAge: (Config_1.config.getOption('cacheInvalidateAfter') || 30) * 1000,
                                store: localStore_1.localStore(Config_1.config.getOption('store')),
                                adapter: exports.api.defaults.adapter,
                            });
                            if (exports.api.defaults.adapter !== cache.adapter) {
                                exports.api.defaults.adapter = cache.adapter;
                            }
                        }
                        headers = {};
                        return [4 /*yield*/, auth_1.auth.getValue(_1.AUTH_VALUES.API_KEY)];
                    case 1:
                        if (!_d.sent()) return [3 /*break*/, 3];
                        _a = headers;
                        _b = 'x-api-key';
                        return [4 /*yield*/, auth_1.auth.getValue(_1.AUTH_VALUES.API_KEY)];
                    case 2:
                        _a[_b] = _d.sent();
                        _d.label = 3;
                    case 3: return [4 /*yield*/, auth_1.auth.getValue(_1.AUTH_VALUES.ACCESS_TOKEN)];
                    case 4:
                        if (!_d.sent()) return [3 /*break*/, 6];
                        _c = headers;
                        return [4 /*yield*/, auth_1.auth.getToken()];
                    case 5:
                        _c.Authorization = (_d.sent());
                        _d.label = 6;
                    case 6:
                        axiosParams = {
                            baseURL: Model.getBaseUrl() + endpoint,
                            data: method === METHOD.POST ||
                                method === METHOD.PUT ||
                                method === METHOD.PATCH
                                ? payload
                                : undefined,
                            headers: __assign({}, headers, extraHeaders),
                            method: method,
                            params: method !== METHOD.POST &&
                                method !== METHOD.PUT &&
                                method !== METHOD.PATCH
                                ? payload
                                : undefined,
                            responseType: responseType,
                        };
                        if (isArrayBrackets) {
                            axiosParams.paramsSerializer = function (params) { return qs_1.stringify(params, { arrayFormat: 'brackets' }); };
                        }
                        return [4 /*yield*/, exports.api(axiosParams)];
                    case 7:
                        result = _d.sent();
                        if (!(result.status === 401 && !reattempt && !headers['x-api-key'])) return [3 /*break*/, 10];
                        return [4 /*yield*/, auth_1.auth.checkAccess()];
                    case 8:
                        access = _d.sent();
                        if (!access) return [3 /*break*/, 10];
                        return [4 /*yield*/, Model.makeRequest(endpoint, method, payload, true)];
                    case 9:
                        reattemptRequest = _d.sent();
                        return [2 /*return*/, reattemptRequest.data];
                    case 10:
                        if (result.status > 304) {
                            throw Error(result.statusText);
                        }
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    Model.getBaseUrl = function () {
        switch (Config_1.config.getOption('mode')) {
            case Config_1.MODE.MOCK:
                return 'http://localhost:3000/v2';
            case Config_1.MODE.QA:
                return 'https://qa-api.trunkrs.app/v2';
            case Config_1.MODE.DEVELOPMENT:
                return 'https://staging-api.trunkrs.app/v2';
            case Config_1.MODE.PRODUCTION:
                return 'https://api.trunkrs.app/v2';
            default:
                return 'https://staging-api.trunkrs.app/v2';
        }
    };
    return Model;
}());
exports.Model = Model;
